// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contactAddressEntity from './entities/contact-address.json';
import contactAddressMenu from '../pages/contact-address/menu.json';
import contactAddressFullForm from '../pages/contact-address/forms/full.json';
import contactAddressContextForm from '../pages/contact-address/forms/context.json';
import contactAddressMiniForm from '../pages/contact-address/forms/mini.json';
import contactAddressLookupForm from '../pages/contact-address/forms/lookup.json';
import contactAddressTableView from '../pages/contact-address/views/table.json';
import contactAddressCardsView from '../pages/contact-address/views/cards.json';
import contactAddressDashboardView from '../pages/contact-address/views/dashboard.json';

/** Тип запису «Адреса контакту» зі сторінками пакета: меню, форми та подання з pages/contact-address/. */
export const contactAddressDefinition: IRecordTypeDefinition = {
  ...contactAddressEntity,
  views: assembleViewSet({
      table: contactAddressTableView,
      cards: contactAddressCardsView,
      dashboard: contactAddressDashboardView,
  }),
  form: contactAddressFullForm,
  forms: { full: contactAddressFullForm, context: contactAddressContextForm, mini: contactAddressMiniForm, lookup: contactAddressLookupForm },
  menu: contactAddressMenu,
} as IRecordTypeDefinition;
